module.exports = __webpack_public_path__ + "img/search-icon-bld.a9a8153c.svg";